<template>
  <List :mapState="'academicCourse'" :allDispatch="'academicCoursesAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/academic/courses/list.vue